import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Radio, Row, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../utils/eventEmitter';
import { Badge } from 'flowbite-react';


const MyFooter = ({ handleSell, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSell} type='primary'>REVERSE</Button>
      <Button onClick={handleCancel} danger>CANCEL</Button>
    </div>
  )
};


const DebitNoteModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [reversal, setReversal] = useState('journal_entry_date');
  
  const onChangeRadio = (e) => setReversal(e.target.value)

  const handleCancel = () => setIsModalOpen(false);
  
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleReverse = () => {
    EventEmitter.dispatch('creating_debit_note', form.getFieldsValue());
  }

  useEffect(() => {
    EventEmitter.subscribe('invoice_debit_note', data => setIsModalOpen(data));
    return () => EventEmitter.unsubscribe('invoice_debit_note');
  },[]);

  
  
  return (
    <Modal title="Debit Note" width={900} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSell={handleReverse}/>}>
      <Form 
        form={form}
        className='border-t-2 py-5' 
        labelAlign='left'
        labelCol={{span: 9}}
        initialValues={{reversal_date: 'journal_entry_date', debit_method: 'partial_refund'}}
        autoComplete="off"
        variant='borderless'
      >
        <Row className='mt-5'>
          <Col md={{span: 11}}>

            <Form.Item label='Debit Method' name="debit_method" className='font-bold mb-4' required>
              <Radio.Group className='flex flex-column' >
                <Space direction='vertical'>
                  <Radio value={'partial_refund'} className='font-normal' >Partial Refund</Radio>
                  <Radio value={'full_refund'} className='font-normal' >Full Refund</Radio>
                  <Radio value={'full_refund_new_invoice'} className='font-normal' >Full Refund and new draft invoice</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={{span: 11, }}>
            <Form.Item label='Reason' name={'reason'} className='font-bold column mb-2' required >
              <Input type='text' placeholder='Enter reason here' className='focus:border-b-2 input-outline-none font-normal w-full'/>
            </Form.Item>
            <Form.Item label='Reversal Date' name="reversal_date" className='font-bold mb-4' required>
              <Radio.Group className='flex flex-column' onChange={onChangeRadio}>
                <Space direction='vertical'>
                  <Radio value={'specific'} className='font-normal'>Specific</Radio>
                  <Radio value={'journal_entry_date'} className='font-normal'>Journal Entry Date</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col md={{span: 11, offset: 1}}>
            <Form.Item label='Use Specific Journal' name={'specific_journal'} className='font-bold column mb-2' required >
              <Select options={[]} />
            </Form.Item>
            {reversal === 'specific'&&<Form.Item label='Refund Date' name={'refund_date'} className='font-bold column mb-2' required >
              <DatePicker className='w-full' />
            </Form.Item>}
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default DebitNoteModal;